import ApplicationAdapter from "./application";

export default class ProjectAdapter extends ApplicationAdapter {
  urlForCreateRecord() {
    return `${this.apiBaseUri}/customer/createproject`;
  }

  urlForUpdateRecord() {
    return `${this.apiBaseUri}/project/edit`;
  }

  urlForDeleteRecord(id) {
    return `${this.apiBaseUri}/project/delete?projectkey=${id}`;
  }

  async findHasMany(store, snapshot, url, relationship) {
    let payload = await super.findHasMany(...arguments);

    if (relationship.type !== "platform-argument") {
      return payload;
    }

    return Object.entries(payload.response.argumentslist.platforms).map(([platform, platformArguments]) => ({
      ...platformArguments,
      id: `${snapshot.id}-${platform}`,
    }));
  }
}
